import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  DoorOpen,
  Activity,
  Users,
  Cpu,
  ShieldAlert,
  Settings,
  Clock,
  Calendar,
  ShieldCheck,
  KeyRound,
  Hotel,
  type LucideIcon,
} from 'lucide-react';
import { TenantSwitcher } from './TenantSwitcher.tsx';
import { trpc } from '../lib/trpc.ts';

interface Props {
  activeStackTeamId: string | null;
  onChangeTenant: (id: string | null) => void;
}

interface Item {
  to: string;
  label: string;
  icon: LucideIcon;
}

const baseItems: Item[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/hotel', label: 'Hotel', icon: Hotel },
  { to: '/doors', label: 'Doors', icon: DoorOpen },
  { to: '/events', label: 'Events', icon: Activity },
  { to: '/cardholders', label: 'Cardholders', icon: Users },
  { to: '/access-levels', label: 'Access levels', icon: ShieldCheck },
  { to: '/schedules', label: 'Schedules', icon: Clock },
  { to: '/holidays', label: 'Holidays', icon: Calendar },
  { to: '/zones', label: 'Zones & alarms', icon: ShieldAlert },
  { to: '/controllers', label: 'Controllers', icon: Cpu },
];

export function Sidebar({ activeStackTeamId, onChangeTenant }: Props) {
  // Developer (API keys) is admin/owner-only.
  const role = trpc.tenant.current.useQuery().data?.role;
  const isAdmin = role === 'admin' || role === 'owner';
  const items: Item[] = [
    ...baseItems,
    ...(isAdmin ? [{ to: '/developer', label: 'Developer', icon: KeyRound } as Item] : []),
    { to: '/settings', label: 'Settings', icon: Settings },
  ];
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="mark">CE</div>
        <span className="brand-text">CDVI Edge</span>
      </div>
      <TenantSwitcher activeStackTeamId={activeStackTeamId} onChange={onChangeTenant} />
      <nav className="nav">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === '/'}
            className={({ isActive }) => `item${isActive ? ' active' : ''}`}
          >
            <it.icon size={16} />
            {it.label}
          </NavLink>
        ))}
      </nav>
      <div className="footer">
        Powered by Bun · Cloudflare · Neon
      </div>
    </aside>
  );
}
